import { extendBatchedMeshPrototypeCommon } from './ExtendBatchedMeshPrototype.common.js';

/**
 * Enhances the BatchedMesh prototype with additional methods.
 */
export function extendBatchedMeshPrototype(): void {
  extendBatchedMeshPrototypeCommon();
}
